import { c as _c } from "react/compiler-runtime";
import { useSubscription } from '@/context/SubscriptionProvider';
import { useCurrentUserRole } from '@/context/UserRoleProvider';
import { useRouter } from 'next/router';
import { ReactNode, useEffect } from 'react';
import { GUARD_ROUTES, SUBSCRIPTION_FREE_ROUTES } from '../config/guard-config';
import { redirectToRoute, shouldRedirect } from '../utils/guard-utils';
import { BaseGuard } from './BaseGuard';
type SubscriptionGuardProps = {
  children: ReactNode;
};
const SubscriptionGuard = t0 => {
  const $ = _c(9);
  const {
    children
  } = t0;
  const router = useRouter();
  const {
    loading,
    hasActiveSubscription
  } = useSubscription();
  const {
    isInternalUser,
    isLoading: isRoleLoading
  } = useCurrentUserRole();
  const shouldAllowAccess = isInternalUser || hasActiveSubscription;
  const isLoading = loading || isRoleLoading;
  let t1;
  let t2;
  if ($[0] !== isLoading || $[1] !== router || $[2] !== shouldAllowAccess) {
    t1 = () => {
      const checkSubscription = async () => {
        if (!isLoading) {
          const shouldRedirectUser = shouldRedirect(router.pathname, SUBSCRIPTION_FREE_ROUTES, shouldAllowAccess);
          if (shouldRedirectUser) {
            await redirectToRoute(router, GUARD_ROUTES.settings.billing, router.pathname);
          }
        }
      };
      checkSubscription();
    };
    t2 = [isLoading, shouldAllowAccess, router.pathname, router];
    $[0] = isLoading;
    $[1] = router;
    $[2] = shouldAllowAccess;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== children || $[6] !== isLoading || $[7] !== shouldAllowAccess) {
    t3 = <BaseGuard guardId="subscription" isLoading={isLoading} shouldAllowAccess={shouldAllowAccess} freeRoutes={SUBSCRIPTION_FREE_ROUTES}>{children}</BaseGuard>;
    $[5] = children;
    $[6] = isLoading;
    $[7] = shouldAllowAccess;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export { SubscriptionGuard };